import React from "react";
import { Building2 } from "lucide-react";

/* ===================== COMPONENTS ===================== */
import ManageOrganisationSearch from "../../components/Organizations/ManageOrganisationSearch";

/* ===================== STYLES ===================== */
import styles from "./Organizations.module.scss";

const Organizations = () => {
  return (
    <div className={styles["admin-orgs__page"]}>
      {/* HEADER SECTION */}
      <div className={styles["admin-orgs__header"]}>
        <div className={styles["admin-orgs__icon-wrapper"]}>
          <Building2 size={24} strokeWidth={2.5} />
        </div>
        <div className={styles["admin-orgs__title-group"]}>
          <h2 className={styles["admin-orgs__title"]}>Organizations</h2>
          <p className={styles["admin-orgs__subtitle"]}>
            View and manage enrolled client organizations.
          </p>
        </div>
      </div>

      {/* MAIN CONTENT WRAPPER */}
      <ManageOrganisationSearch />
    </div>
  );
};

export default Organizations;
